<!--
 * @Description: 
 * @Author: zml
 * @Date: 2025-02-10 09:08:05
 * @LastEditors: zml
 * @LastEditTime: 2025-05-13 11:39:25
-->
<template>
    <div class="header-box">
        <div class="header-top"><header-top></header-top></div>
        <logo-box></logo-box>
        <nav-bar></nav-bar>
    </div>
</template>

<script>
    import headerTop from '@/components/headerTop/index'
    import logoBox from '@/components/logoBox/index'
    import navBar from '@/components/navBar/index'
    export default {
        components: {
            headerTop,
            logoBox,
            navBar
        }
    }
</script>
<style lang="scss" scoped>
    .header-box {
        & .header-top {
            margin-bottom: 33px;
        }
    }
</style>